import { Send, UserRoundPlus } from "lucide-react";
import { Text } from "@/components/Typography";
import { cn } from "@/utils/cn";

interface PabInvitationsProgressProps {
  count: number;
  total: number;
  description: string;
  variant?: "page" | "modal";
}

export const PabInvitationsProgress = ({
  count,
  total,
  description,
  variant = "page",
}: PabInvitationsProgressProps) => {
  if (variant === "modal") {
    return (
      <div className="flex items-center gap-3 min-w-0">
        <div className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-600 shrink-0">
          <UserRoundPlus className="h-4 w-4 text-white" />
        </div>
        <div className="min-w-0">
          <Text
            as="p"
            className="text-[13px] font-semibold text-secondary-900 dark:text-white truncate"
          >
            Advisory Board Invitations Sent
          </Text>
          <Text
            as="p"
            className="text-[12px] text-accent-250 dark:text-pab-dark-subtle-text truncate"
          >
            {description}
          </Text>
        </div>
        <Text
          as="span"
          className="text-[14px] font-bold text-secondary-900 dark:text-white shrink-0 ml-2"
        >
          {count}/{total}
        </Text>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 sm:gap-6">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px] bg-primary-gradient">
        <Send className="h-3.5 w-3.5 text-white" />
      </div>
      <div className="hidden flex-col sm:flex">
        <Text as="p" className="text-14 font-semibold leading-5 text-secondary-900 dark:text-white">
          Advisory Board Invitations Sent
        </Text>
        <Text
          as="p"
          className="text-[11px] leading-[16.5px] text-accent-250 dark:text-pab-dark-subtle-text"
        >
          {description}
        </Text>
      </div>
      <div className="flex items-center gap-2.5">
        <div className="flex items-center gap-1">
          {Array.from({ length: total }).map((_, i) => (
            <span
              key={i}
              className={cn(
                "h-2 w-10 rounded-full transition-colors duration-300",
                i < count ? "bg-progress-gradient" : "bg-secondary-200 dark:bg-surface-card-inner",
              )}
            />
          ))}
        </div>
        <span className="text-14 font-bold text-goals-purple-selected">
          {count}/{total}
        </span>
      </div>
    </div>
  );
};
